import { render } from "./SurnameProfilePanel.vue?vue&type=template&id=10c567c3&scoped=true"
import script from "./SurnameProfilePanel.vue?vue&type=script&lang=js"
export * from "./SurnameProfilePanel.vue?vue&type=script&lang=js"

import "./SurnameProfilePanel.vue?vue&type=style&index=0&id=10c567c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c567c3"]])

export default __exports__